import { z } from 'zod';

const FrequencySchema = z.object({
  unit: z.string(),
  value: z.string(),
});

const CheckoutSessionWebCheckoutDetailsSchema = z
  .object({
    checkoutReviewReturnUrl: z.string(),
    checkoutResultReturnUrl: z.string(),
    amazonPayRedirectUrl: z.string(),
  })
  .nullable();

const CheckoutSessionPaymentDetailsSchema = z.object({
  canHandlePendingAuthorization: z.boolean(),
  paymentIntent: z.string(),
});

const CheckoutSessionRecurringMetadataSchema = z.object({
  amount: z.unknown().nullable(),
  frequency: FrequencySchema,
});

const StatusDetailsSchema = z.object({
  state: z.string(),
  reasonCode: z.unknown().nullable(),
  reasonDescription: z.unknown().nullable(),
  lastUpdatedTimestamp: z.string(),
});

const BillingAddressSchema = z
  .object({
    name: z.string(),
    addressLine1: z.string(),
    addressLine2: z.string().nullable(),
    addressLine3: z.string().nullable(),
    city: z.string(),
    county: z.string().nullable(),
    district: z.string().nullable(),
    stateOrRegion: z.string().nullable(),
    postalCode: z.string().nullable(),
    countryCode: z.string(),
    phoneNumber: z.string().nullable(),
  })
  .nullable();

export const AmazonPayCheckoutSessionResponseSchema = z.object({
  checkoutSessionId: z.string(),
  webCheckoutDetails: CheckoutSessionWebCheckoutDetailsSchema,
  productType: z.string().nullable(),
  paymentDetails: CheckoutSessionPaymentDetailsSchema.nullable(),
  chargePermissionType: z.string(),
  recurringMetadata: CheckoutSessionRecurringMetadataSchema.nullable(),
  checkoutType: z.unknown().nullable(),
  statusDetails: StatusDetailsSchema,
  billingAddress: BillingAddressSchema,
  creationTimestamp: z.string(),
  expirationTimestamp: z.string(),
  storeId: z.string().nullable(),
  releaseEnvironment: z.string().nullable(),
  amazonPayToken: z.string().nullable(),
});

// Export TypeScript Type
export type AmazonPayCheckoutSessionResponse = z.infer<typeof AmazonPayCheckoutSessionResponseSchema>;
